import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "row", "status"]

  connect() { this.refresh() }

  refresh() {
    this.rowTargets.forEach(row => {
      const selected = row.querySelector("input[type=checkbox]").checked
      row.hidden = !selected
      row.querySelector("input[type=number]").disabled = !selected
    })
    this.search()
  }

  search() {
    const query = this.inputTarget.value.trim().toLocaleLowerCase("ru")
    this.resultsTarget.replaceChildren()
    this.inputTarget.setAttribute("aria-expanded", "false")
    if (!query) {
      this.statusTarget.textContent = "Начните вводить название услуги. После выбора проверьте галочку и цену."
      return
    }
    const words = query.split(/\s+/)
    const matches = this.rowTargets.filter(row => !row.querySelector("input[type=checkbox]").checked && words.every(word => `${row.dataset.name} ${row.dataset.category}`.toLocaleLowerCase("ru").includes(word)))
    matches.slice(0, 10).forEach(row => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "list-group-item list-group-item-action text-start"
      button.textContent = `${row.dataset.name} · ${row.dataset.category} · ${row.dataset.hint}`
      button.addEventListener("click", () => {
        const checkbox = row.querySelector("input[type=checkbox]")
        checkbox.checked = true
        this.inputTarget.value = ""
        checkbox.dispatchEvent(new Event("change", {bubbles: true}))
        row.querySelector("input[type=number]").focus()
      })
      button.addEventListener("keydown", event => {
        if (event.key === "Escape") { this.close(); this.inputTarget.focus() }
        if (event.key === "ArrowDown") { event.preventDefault(); button.nextElementSibling?.focus() }
        if (event.key === "ArrowUp") { event.preventDefault(); (button.previousElementSibling || this.inputTarget).focus() }
      })
      this.resultsTarget.append(button)
    })
    this.inputTarget.setAttribute("aria-expanded", String(matches.length > 0))
    this.statusTarget.textContent = matches.length ? `Найдено: ${matches.length}. Выберите услугу.${matches.length > 10 ? " Уточните запрос, чтобы увидеть остальные." : ""}` : "Совпадений нет или услуга уже выбрана. Можно создать новую ниже."
  }

  keydown(event) {
    if (event.key === "ArrowDown") { event.preventDefault(); this.resultsTarget.firstElementChild?.focus() }
    if (event.key === "Escape") this.close()
    if (event.key === "Enter") { event.preventDefault(); this.resultsTarget.firstElementChild?.click() }
  }

  close() { this.resultsTarget.replaceChildren(); this.inputTarget.setAttribute("aria-expanded", "false") }
}
